export default function BootstrapDatepickerFormatValidator() {
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    link: function(scope, elem, attrs, ctrl) {
                        ctrl.$validators.dateFormat = function(value) {
                            return (!attrs.required && !value)
                                || moment(value, attrs.ngDateFormat, true).isValid();
                        };
                    },
                };
}



// WEBPACK FOOTER //
// ./src/app/directives/bootstrapDatepickerFormatValidator.directive.js